import { queryParamHas } from '../helpers/getQueryParam'

/* eslint-disable no-magic-numbers */
export const MAX_TARGETING_LENGTH = 40
export const SLUG_ATTRIBUTE = 'data-slug'
export const TABLET_WIDTH = 728
export const DFP_ID = '1030006'
export const desktopOffsetMultiplier = 2.5
export const mobileOffsetMultiplier = 2.9
export const offsetTest = false
export const timeoutTest = false
export const DEFAULT_REFRESH_INTERVAL = queryParamHas('noRefresh', 'true')
  ? 0
  : 28 // seconds
export const MAX_REFRESH_RETRIES = 3
export const PENNY_PRECISION = 2
export const SLOT_RENDER_ATTR = 'data-slot-rendered'
export const DEPRECATED_BLOCKLIST_ATTR = 'data-blacklist-'
export const BLOCKLIST_ATTR = 'data-blocklist-'
export const DEPRECATED_BLOCKLIST = 'blacklist'
export const BLOCKLIST = 'blocklist'
export const ALL = 'all'
export const OUTSTREAM_FLOOR = 2.5
export const GVL_MINIMUM_VERSION = 59
export const TCF_API_VERSION = 2
export const TCF_CMP_ID = 46
export const TCF_COOKIE_EXPIRES = 365 * 24 * 60 * 60 // seconds in a year
export const TCF_COOKIE_EXPIRE_MS = TCF_COOKIE_EXPIRES * 1000
export const TCF_DEFAULT_COUNTRY = 'US'
export const TCF_SERVICE_SPECIFIC_SCOPE = true
export const TCF_PURPOSE_1 = 1
export const TCF_PURPOSE_2 = 2
export const TCF_VENDOR_ID_GOOGLE = 755
export const TCF_VENDOR_ID_MEDIAVINE = 858
export const  MV_CMP_VERSION = 'v1'

export const BANNER_LINE_ITEM_VERSION = '4'
export const OUTSTREAM_LINE_ITEM_VERSION = 'out_2'
export const NATIVE_LINE_ITEM_VERSION = '1_native'
export const STICKY_OUTSTREAM_LINE_ITEM_VERSION = 'stickyout_1'
export const TAM_BANNER_LINE_ITEM_VERSION = 'tam_1'
export const TAM_OUTSTREAM_LINE_ITEM_VERSION = 'tamout_1'
export const TAM_STICKY_OUTSTREAM_LINE_ITEM_VERSION = 'tamstickyout_1'
export const AMAZON_GUMGUM = '1uktatc'

export const REFRESH_MINIMUM_VISIBILITY = 0.51
export const ADHESION_NATIVE_BODY_CLASS = 'mv-adhesion-native'

// These constants exist here to facilitate smaller chunk sizes.
// They would fit better elsewhere, but live here to avoid importing the entire file where they would fit better.
export const AD_BOX_SELECTOR = `mv-ad-box`
